import { render } from "./AdminNavbarComponent.vue?vue&type=template&id=24e4b31c&scoped=true"
import script from "./AdminNavbarComponent.vue?vue&type=script&lang=js"
export * from "./AdminNavbarComponent.vue?vue&type=script&lang=js"

import "./AdminNavbarComponent.vue?vue&type=style&index=0&id=24e4b31c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e4b31c"]])

export default __exports__